import type { ParticipantBehaviourRecording } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const participantBehaviourTypeColorName = (
  type: ParticipantBehaviourRecording['__typename'],
) => {
  switch (type) {
    case 'ParticipantBehaviourRecordingAbc':
      return ['blue', 'ABC'];
    case 'ParticipantBehaviourRecordingDuration':
      return ['yellow', 'Duration'];
    case 'ParticipantBehaviourRecordingEpisodicSeverity':
      return ['green', 'Episodic Severity'];
    case 'ParticipantBehaviourRecordingFrequency':
      return ['red', 'Frequency'];
    case undefined:
      return ['gray', 'Unknown'];
  }
};

interface Props extends ChakraV3.TagProps {
  type: ParticipantBehaviourRecording['__typename'];
}

export const ParticipantBehaviourRecordingTypeTag = (props: Props) => {
  const { type, ...rest } = props;

  const [color, name] = participantBehaviourTypeColorName(type);

  return (
    <ChakraV3.Tag colorPalette={color} {...rest}>
      {name}
    </ChakraV3.Tag>
  );
};
